import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Tab, Box, Dialog, TextField, Button, CircularProgress } from "@mui/material";
import {
    fetchHealthDetailsBanner, fetchHealthCheckupDetailsBySlug, fetchHealthCheckupDetails,
    submitHealthCheckupForm, sendHealthCheckupToCRM
} from "../Adapter/PageAdapter";
import useSeo from "../hooks/useSeo";
import SeoHelmet from "../components/SeoHelmet";
import { NavLink } from "react-router-dom";
import healthDetail from "../assets/images/speci-detail/healthdetl.jpg";
import HealthBanner from "../assets/images/healtch-checkup.png";
import arrSvg from "../assets/images/arrw.svg";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import { baseImage_path } from '../variables/Variables';

const HealthCheckupDetails = () => {
    const [bannerData, setBannerData] = useState(null);
    const { slug } = useParams();
    const [healthCheckup, setHealthCheckup] = useState(null);
    const [checkupId, setCheckupId] = useState(null);
    const [healthPackages, setHealthPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        appointmentDate: new Date().toISOString().split('T')[0],
        message: "",
    });
    const [activeTab, setActiveTab] = useState(0);

    const seoData = useSeo(fetchHealthCheckupDetails);

    useEffect(() => {
        const fetchHealthCheckups = async () => {
            try {
                const response = await fetchHealthCheckupDetailsBySlug(slug);
                if (response && response.data) {
                    // setHealthPackages(response.data);
                    setHealthCheckup(response.data);
                }
            } catch (error) {
                console.error("Error fetching health checkup details:", error);
            }
        };

        fetchHealthCheckups();
    }, [slug]);

    useEffect(() => {
        const fetchAllPackages = async () => {
            try {
                const response = await fetchHealthCheckupDetails(); // this returns all packages
                if (response && Array.isArray(response.data)) {
                    setHealthPackages(response.data);
                }
            } catch (error) {
                console.error("Error fetching all health checkup packages:", error);
            }
        };

        fetchAllPackages();
    }, []);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        setFormData((prev) => ({ ...prev, appointmentDate: formattedDate }));
    }, []);

    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];

    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3);
    const formattedMax = maxDate.toISOString().split("T")[0];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;

        if (!formData.appointmentDate) {
            toast.error("Please select a valid appointment date and time.", { position: "top-center" });
            return;
        }

        setLoading(true);

        // Prepare payload object
        const payload = {
            health_checkup_package_id: healthCheckup?.checkup_id || "",
            full_name: formData.name,
            phone: formData.phone,
            email: formData.email,
            appointment_date: formData.appointmentDate,
            message: formData.message
        };

        try {
            const response = await submitHealthCheckupForm(payload);

            if (response?.message) {

                await sendHealthCheckupToCRM(formData);
                toast.success(response.message, { position: "top-center" });
                handleClose(); // Close the modal on success

                // Reset form state
                setFormData({
                    name: "",
                    phone: "",
                    email: "",
                    appointmentDate: "",
                    message: ""
                });
            }
        } catch (error) {
            toast.error("Failed to submit the form. Please try again.", { position: "top-center" });
        } finally {
            setLoading(false); // Stop the loader
        }
    };

    if (!healthCheckup) {
        return <p>No health checkup details found: {checkupId}</p>;
    }

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <>
            {/* Banner Section */}
            <section className="banner-spac">
                <div className="cust-container">
                    <div className="banner-box">
                        {healthCheckup && healthCheckup.banner_img ? (
                            <img
                                src={`${baseImage_path}${healthCheckup.banner_img.replace(/^\./, "")}`}
                                alt="Health Checkup Banner"
                            />
                        ) : (
                            <img
                                src={HealthBanner}
                                alt="Default Banner"
                            />
                        )}
                        <div className="ban-con">
                            <h1>Health Check Ups</h1>
                        </div>
                    </div>
                </div>
            </section>

            <Toaster position="top-right" />

            {/* Health Checkup Details Section */}
            <section className="heatlchup-detail-sec mrgntop70 margnbot90">
                <div className="cust-container">
                    <div className="row">
                        {/* Left Section */}
                        <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
                            <div className="healthchkdetail-left">
                                <div className="healthdetailcard">
                                    <div className="health-cardimg">
                                        <img
                                            src={healthCheckup?.checkup_image
                                                ? `${baseImage_path}${healthCheckup.checkup_image.replace(/^\./, "")}`
                                                : HealthBanner}
                                            alt={healthCheckup?.health_checkup_name || "Health Checkup"}
                                        />
                                    </div>
                                    <div className="healthdetail-carddesc">
                                        <h4>{healthCheckup.health_checkup_name || "N/A"}</h4>
                                        <p>
                                            Email: <a href="mailto:info@rahejahospital.com">{healthCheckup.email}</a>
                                        </p>
                                        <p>
                                            Phone: <a href="tel:022-69871211">{healthCheckup.phone}</a>
                                        </p>
                                        {/* <span>Fees: Rs. {healthCheckup.checkup_fees}/-</span> */}
                                        <p style={{ color: "#0ca854", fontWeight: "bold" }}>
                                            <strong></strong> Rs. {healthCheckup.checkup_fees}/-
                                        </p>

                                        <div className="healthdetail-carddesc-cta">
                                            <a href="#" className="btn with-color with-arr" onClick={handleOpen}>
                                                <img src={arrSvg} alt="Book Now" className="ctaimgwht" /> Book Now
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                {/* Tabs for Test Inclusions & Package Instructions */}
                                <Box sx={{
                                    borderBottom: 1, borderColor: "divider",
                                    marginTop: "20px", backgroundColor: '#0ca854', borderRadius: '0px 50px 50px 0px'
                                }}>
                                    <Tabs value={activeTab} onChange={handleTabChange} className="custom-tabs">
                                        <Tab label="Test Inclusions" style={{ color: "#fff" }} />
                                        <Tab label="Package Instructions" style={{ color: "#fff" }} />
                                    </Tabs>
                                </Box>

                                {/* Tab Content */}
                                {activeTab === 0 && (
                                    <div className="health-detail-pkg-detail" style={{ marginTop: '30px' }}>
                                        {/* <h5>Test Inclusions</h5> */}
                                        <div className="health-details">
                                            {healthCheckup.test_master &&
                                                healthCheckup.test_master.map((testCategory, index) => (
                                                    <div key={index} className="health-details">
                                                        <p>{testCategory.test_master_name}</p>
                                                        <ul>
                                                            {testCategory.test_inclusion &&
                                                                testCategory.test_inclusion.length > 0 ? (
                                                                testCategory.test_inclusion.map((test, idx) => (
                                                                    <li key={idx}>{test.test_inclusion_name}</li>
                                                                ))
                                                            ) : (
                                                                <li>No tests included in this category.</li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                )}

                                {activeTab === 1 && (
                                    <div className="package-instructions" style={{ marginTop: '30px' }}>
                                        {/* <h5>Package Instructions</h5> */}
                                        <div className="health-details">
                                            <h5>Instructions for Health Check-Up</h5>
                                            <ul>
                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Appointment Timings:</strong>  <br />&nbsp;Schedule in advance. Check-ups start from 8:00 AM to 8:30 AM.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Fasting Packages:</strong> <br />&nbsp;For fasting packages, appointments are only up to 10:30 AM for accurate results.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Fasting Requirements:</strong> <br />&nbsp;Fast for 8–12 hours before your check-up. You may drink plain water.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Medication:</strong> <br />&nbsp;Bring your medicines and take them after breakfast during the check-up. Inform staff if you feel discomfort.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Diabetic Patients:</strong> <br />&nbsp;Skip morning insulin; take it with breakfast after the fasting blood sample.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Smoking:</strong> <br />&nbsp;Avoid smoking on the day of the check-up.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>For Women:</strong> <br />&nbsp;Avoid check-ups during menstruation. Pregnant women must avoid X-rays, mammography, or bone densitometry.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Clothing:</strong> <br />&nbsp;Wear loose, comfortable clothes and footwear.
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Attendant:</strong> <br />&nbsp;Bring an attendant if needed (no children below 12 years).
                                                </li>

                                                <li style={{ marginTop: '15px' }}>
                                                    <strong>Clinical Conditions:</strong> <br />&nbsp;Inform staff if you are diabetic, hypertensive (high blood pressure), pregnant, or have any health conditions.
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Right Section - Health Checkup Packages List */}
                        <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
                            <div className="healthchkdetail-right">
                                <div className="health-chkup-pkgslist">
                                    <h4>Health Checkup Packages</h4>
                                    <ul>
                                        {healthPackages.map((pkg) => (
                                            <li key={pkg.slug}>
                                                <NavLink to={`/health-checkup/${pkg.slug}`} style={{ textDecoration: "none", color: "inherit" }}>
                                                    {pkg.health_checkup_name}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

            {/* Application Modal */}
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <form onSubmit={handleSubmit}>
                    <Box p={3}>
                        <h3>Book Now - {healthCheckup?.health_checkup_package_name || ""}</h3>

                        <TextField
                            fullWidth
                            label="Full Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />

                        <TextField
                            fullWidth
                            label="Phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />

                        <TextField
                            fullWidth
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            margin="normal"
                            required
                        />

                        {/* <TextField
                            fullWidth
                            label="Appointment Date & Time"
                            name="appointmentDate"
                            type="datetime-local"
                            value={formData.appointmentDate}
                            onChange={handleChange}
                            margin="normal"
                            required
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                min: new Date().toISOString().slice(0, 16),
                                max: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().slice(0, 16)
                            }}
                        /> */}
                        <TextField
                            fullWidth
                            label="Appointment Date"
                            name="appointmentDate"
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                min: formattedToday,
                                max: formattedMax,
                            }}
                            value={formData.appointmentDate}
                            onChange={handleChange}
                            margin="normal"
                        />

                        <TextField
                            fullWidth
                            label="Message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            margin="normal"
                            multiline
                            rows={3}
                        />

                        <Box mt={2} display="flex" justifyContent="flex-end">
                            <Button
                                onClick={handleClose}
                                style={{ marginRight: "8px" }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={24} /> : "Submit"}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Dialog>
        </>
    );
};

export default HealthCheckupDetails;